'use strict';

const settings = {
    "EventID" : 49337,
    "baseURI" : 'https://ccq-functions.azurewebsites.net/api',
    "languageCode" : "languageCode=en-CA",
    "sortBy" : "sortBy=onlineAmount",
    "listItemCount" : "listItemCount=5",
    "wordpressPostID" : 34851,
    //34851
    //141
    "instagramClientID" : '4f436d8e938b428a9f20a57451006699'
}

export default settings;


// WEBPACK FOOTER //
// ./src/js/settings.js